import React from "react";
import { Link } from "react-router-dom";
import { logo } from "../../assets/Images";
import { ImageUrl } from "../../services/API.js";

export default function AuthBrandMark({ settings, to = "/" }) {
  const src = settings?.brandLogo ? `${ImageUrl}${settings.brandLogo}` : logo;

  return (
    <div className="mb-8 text-center">
      <Link
        to={to}
        className="inline-block rounded-xl outline-none ring-offset-2 ring-offset-transparent transition hover:opacity-95 focus-visible:ring-2 focus-visible:ring-primaryBlue"
      >
        <img
          src={src}
          alt="The Weather Agency"
          className="mx-auto h-20 w-auto max-w-[200px] object-contain sm:h-24"
        />
      </Link>
    </div>
  );
}
